import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

// const options = { role: ROLE.SUPER_ADMIN };
const options = {};
const path = "admin/temple-service";

export const TempleServiceList = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const TempleServiceAdd = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const TempleServiceDelete = async (id) => {
  return await axiosInstance(options).delete(`${path}/delete`, {
    params: { o_id: id },
  });
};

export const TempleServiceDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
};

export const TempleServiceEdit = async (values) => {
  return await axiosInstance(options).post(`${path}/edit`, values);
};


export const TempleServiceStatusChange = async (values) => {
  return await axiosInstance(options).post(`${path}/change-status`, values);
};